module.exports = __webpack_public_path__ + "img/3rd-anniversary.01d04d2.webp";